import { z } from "zod";
import {
  ERP_SYNC_CONFIG_PROPERTY_ORDER,
  ERPSyncConfigSchema,
  OpportunityCustomFieldMappingSchema,
} from "./schemas";

/**
 * Per-customer Prophet 21 sync configuration. Stored as `integrationConfig`
 * jsonb on the `erpIntegrationSyncsTable` row. Extends the shared
 * {@link ERPSyncConfigSchema} with the quote taker Prophet 21 requires on
 * every Order transaction, the revision overwrite toggle, and the item custom
 * field mapping. The Prophet 21 company id belongs to the connection, not the sync.
 */
export const Prophet21SyncConfigSchema = ERPSyncConfigSchema.extend({
  taker: z.string().min(1).meta({
    title: "Quote taker",
    description: "Prophet 21 user id recorded as the taker on pushed quotes",
  }),
  overwriteQuoteOnRevision: z.boolean().default(false).meta({
    title: "Overwrite the Prophet 21 quote on a new revision",
    description:
      "Update the existing Prophet 21 quote in place when a new Forgepoint revision is finalized, instead of creating a second Prophet 21 quote.",
  }),
  itemCustomFieldMapping: OpportunityCustomFieldMappingSchema.meta({
    title: "Item custom field mapping",
    description:
      "Map Forgepoint item custom fields to Prophet 21 user-defined item fields",
  }),
});

/** Per-customer Prophet 21 sync configuration. */
export type Prophet21SyncConfig = z.infer<typeof Prophet21SyncConfigSchema>;

/** Display order for the Prophet 21 sync config properties. */
export const PROPHET21_SYNC_CONFIG_PROPERTY_ORDER: string[] = [
  ...ERP_SYNC_CONFIG_PROPERTY_ORDER,
  "taker",
  "overwriteQuoteOnRevision",
  "itemCustomFieldMapping",
];
